import type { Uuid } from '@cyphex/types';

const HEX = '0123456789abcdef';

/** RFC-4122 v4 UUID. Uses `crypto.randomUUID` when available. */
export function newUuid(): Uuid {
  const c = globalThis.crypto;
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();

  const bytes = new Uint8Array(16);
  if (c && typeof c.getRandomValues === 'function') c.getRandomValues(bytes);
  else for (let i = 0; i < 16; i += 1) bytes[i] = Math.floor(Math.random() * 256);

  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;

  let out = '';
  for (let i = 0; i < 16; i += 1) {
    const b = bytes[i] ?? 0;
    if (i === 4 || i === 6 || i === 8 || i === 10) out += '-';
    out += (HEX[b >> 4] ?? '0') + (HEX[b & 15] ?? '0');
  }
  return out;
}

/** Short, collision-safe key for purely local objects (attachments, rows). */
export function localKey(prefix: string): string {
  return `${prefix}_${Math.random().toString(36).slice(2, 10)}`;
}
